import Vue from "vue";
import VueRouter from "vue-router";
import Check from "../views/check.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Check",
    component: Check,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
